import { Datetime } from '@/utils';
import { Import } from '@/models/gen/graphql';
import PromiseButton from 'components/PromiseButton';
import { ReactElement } from 'react';
import Table from '@/common/Table';

type ImportHistoryTableRowProps = {
  row: Import;
  onDownload: (id: string, name?: string) => Promise<void>;
  onRollback: (id: string) => Promise<void>;
};

const ImportHistoryTableRow = ({ row, onDownload, onRollback }: ImportHistoryTableRowProps): ReactElement => {
  const {
    id,
    archivedAt,
    ingestStarted,
    updatedAt,
    type,
    name,
    email,
    provider,
    filename,
    ingestedByUser,
    total,
    created,
    updated,
    deleted,
    unchanged,
    rolledBackAt,
    rolledBackUser,
    from,
  } = row;

  return (
    <Table.Row
      id={id}
      onDoubleClick={
        !rolledBackAt
          ? (): void => {
              window.location.href = `/manifests/${id}${window.location.search}`;
            }
          : undefined
      }
    >
      <Table.Cell className="DATE alternate" data-placeholder="--">
        <div className="ImportHistoryTableRow-Date d-flex justify-content-center">
          {new Datetime().setAsUTC(archivedAt || ingestStarted || updatedAt).toLocaleDatetime().frontendDatetimeShort}
        </div>
      </Table.Cell>
      <Table.Cell className="TYPE" data-placeholder="--">
        {type || ''}
      </Table.Cell>
      <Table.Cell className="NAME alternate" data-placeholder="--">
        {name || from || ''}
      </Table.Cell>
      <Table.Cell className="PROVIDER" data-placeholder="--">
        {provider?.displayName || ''}
      </Table.Cell>
      <Table.Cell className="FILENAME alternate" data-placeholder="--">
        {filename || email?.subject || ''}
      </Table.Cell>
      <Table.Cell className="IMPORTED-BY" data-placeholder="--">
        {ingestedByUser || ''}
      </Table.Cell>
      <Table.Cell className="TOTAL" data-placeholder="--">
        {total ?? ''}
      </Table.Cell>
      <Table.Cell className="CREATED bg-success bg-opacity-25 text-black" data-placeholder="--">
        {created ?? ''}
      </Table.Cell>
      <Table.Cell className="UPDATED bg-warning bg-opacity-25" data-placeholder="--">
        {updated ?? ''}
      </Table.Cell>
      <Table.Cell className="DELETED bg-danger bg-opacity-25 text-black" data-placeholder="--">
        {deleted ?? ''}
      </Table.Cell>
      <Table.Cell className="UNCHANGED alternate" data-placeholder="--">
        {unchanged ?? ''}
      </Table.Cell>
      <Table.Cell className="ACTIONS" data-placeholder="--">
        <div className="ImportHistoryTableRow-Actions d-flex justify-content-center">
          {!rolledBackAt && (
            <>
              <div className="ImportHistoryTableRow-Download" style={{ overflow: 'hidden', width: 'calc(100% / 2)' }}>
                <PromiseButton
                  variant="transparent"
                  onClick={() => onDownload(id)}
                  icon={<i className="sv sv-download2 fs-3" />}
                  feedback="Download"
                />
              </div>
              <div className="ImportHistoryTableRow-Delete" style={{ overflow: 'hidden', width: 'calc(100% / 2)' }}>
                <PromiseButton.Confirmation
                  variant="transparent"
                  feedback="Delete"
                  options={{ confirmation: { Body: { message: 'Are you sure you want to delete Manifest ?' } } }}
                  icon={<i className="sv sv-cross-square fs-3 text-danger" />}
                  onClick={() => onRollback(id)}
                />
              </div>
            </>
          )}
          {!!rolledBackAt && (
            <div className="ImportHistoryTableRow-RolledBack" style={{ overflow: 'hidden' }}>
              <span>Deleted by {rolledBackUser?.fullName} On</span>
              <br />
              {new Datetime().setAsUTC(rolledBackAt).toLocaleDatetime().format('MMMM DD, YYYY HH:mm')}
            </div>
          )}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

export default ImportHistoryTableRow;
